import { IColorMaterialDescriptionPage } from "@montana/models/generated/cms.interface";
import { Container } from "@montana/shared/container"
import React from "react"
import { ColorMaterialView } from "./color-material-view.component";

export const ColorMaterialPage: React.VFC<IColorMaterialDescriptionPage> = (props) => {
    return (
        <Container className="color-material-page">
            <ColorMaterialView {...props} />
        </Container>
    );
}
